document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.svc-expand-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.svc-item');
      const acc  = item.querySelector('.svc-acc');
      const open = acc.classList.toggle('open');
      btn.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open);
    });
  });
});